export const APP_NAME = 'pac-service-plan-app';

export enum Card {
  CLASSIC = 'CLASSIC',
  DEBIT = 'DEBIT',
  DUO = 'DUO',
  GOLD = 'GOLD',
  PLATINUM = 'PLATINUM',
}

export enum Age {
  AGE_18_TO_25,
  AGE_26_TO_29,
  AGE_OVER_30,
}

export enum ServicePlanId {
  OP_CLASSIC = 'OP_CLASSIC',
  OP_CLASSIC_PLUS_OP_DUO = 'OP_CLASSIC_PLUS_OP_DUO',
  OP_DEBIT = 'OP_DEBIT',
  OP_GOLD = 'OP_GOLD',
  OP_GOLD_PLUS_OP_DUO = 'OP_GOLD_PLUS_OP_DUO',
  OP_PLATINUM = 'OP_PLATINUM',
}
